import React, { useState } from 'react';
import axios from 'axios';
import { Loader2, Plus } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';

const API = process.env.REACT_APP_BACKEND_URL;

const FIELDS = [
  { field: 'name', label: 'Name *', type: 'text', required: true },
  { field: 'email', label: 'Email *', type: 'email', required: true },
  { field: 'phone', label: 'Phone', type: 'tel' },
  { field: 'company', label: 'Company', type: 'text' },
  { field: 'state', label: 'State', type: 'text' },
  { field: 'energy_type', label: 'Energy Type', type: 'text' },
];

export const NewDealModal = ({ onClose, onCreated }) => {
  const [data, setData] = useState({ name: '', email: '', phone: '', company: '', state: '', energy_type: '' });
  const [submitting, setSubmitting] = useState(false);

  const createDeal = async (e) => {
    e.preventDefault();
    if (!data.name.trim() || !data.email.trim()) return;
    setSubmitting(true);
    try {
      await axios.post(`${API}/api/admin/deals`, data, { withCredentials: true });
      onCreated();
      onClose();
    } catch (err) {
      console.error('Failed to create deal:', err);
    }
    setSubmitting(false);
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 200,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <div style={{
        background: '#fff', borderRadius: 12, padding: '1.5rem', width: 480, maxWidth: '90vw',
        boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
      }}>
        <h3 style={{ fontFamily: 'var(--font-heading)', fontSize: '1.125rem', fontWeight: 700, color: 'var(--navy)', marginBottom: '1rem' }}>
          Add New Deal
        </h3>
        <form onSubmit={createDeal}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem', marginBottom: '1rem' }}>
            {FIELDS.map(f => (
              <div key={f.field}>
                <label style={{ fontSize: '0.7rem', fontWeight: 600, color: '#9CA3AF', textTransform: 'uppercase', display: 'block', marginBottom: 4 }}>
                  {f.label}
                </label>
                <Input
                  type={f.type}
                  value={data[f.field]}
                  onChange={(e) => setData({ ...data, [f.field]: e.target.value })}
                  required={f.required}
                  data-testid={`new-deal-${f.field}`}
                  style={{ background: '#fff', border: '1px solid #E5E7EB', color: 'var(--navy)' }}
                />
              </div>
            ))}
          </div>
          <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end' }}>
            <Button type="button" onClick={onClose} variant="outline">Cancel</Button>
            <Button type="submit" disabled={submitting} className="btn-primary" data-testid="create-deal-btn">
              {submitting ? <Loader2 size={14} className="animate-spin mr-2" /> : <Plus size={14} className="mr-2" />}
              Create Deal
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};
